import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["versionCheckbox", "tagSelect", "generateButton", "versionCount", "discoveryCount"]

  connect() {
    this.updateGenerateButtonLabel()

    // Handle form submission to add hidden fields
    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.closest('form').addEventListener('submit', this.prepareFormSubmission.bind(this))
    }

    // Set initial state from cookies if they exist
    this.initializeFromCookies()
  }

  initializeFromCookies() {
    // Read cookies if they exist
    const tagIdsCookie = this.getCookie('tag_ids')
    const versionIdsCookie = this.getCookie('persona_version_ids')

    if (tagIdsCookie && versionIdsCookie && this.hasTagSelectTarget && this.hasVersionCheckboxTarget) {
      try {
        const tagIds = JSON.parse(tagIdsCookie)
        const versionIds = JSON.parse(versionIdsCookie)

        // Select the tags
        if (Array.isArray(tagIds)) {
          Array.from(this.tagSelectTarget.options).forEach(option => {
            option.selected = tagIds.includes(parseInt(option.value)) || tagIds.includes(option.value)
          })
        }

        // Check the versions
        if (Array.isArray(versionIds)) {
          this.versionCheckboxTargets.forEach(checkbox => {
            checkbox.checked = versionIds.includes(parseInt(checkbox.value)) || versionIds.includes(checkbox.value)
          })
        }

        // Update UI
        this.updateGenerateButtonLabel()
      } catch (e) {
        console.error("Error parsing cookies:", e)
      }
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  toggleVersion() {
    this.updateGenerateButtonLabel()
  }

  updateTagSelection() {
    this.updateGenerateButtonLabel()
  }

  prepareFormSubmission(event) {
    const form = event.target

    // Clear any existing hidden fields
    const existingHiddenVersions = form.querySelectorAll('input[name="persona_version_ids[]"]')
    const existingHiddenTags = form.querySelectorAll('input[name="tag_ids[]"]')

    existingHiddenVersions.forEach(el => el.remove())
    existingHiddenTags.forEach(el => el.remove())

    // Add hidden fields for each selected version
    this.selectedVersions.forEach(versionId => {
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'persona_version_ids[]'
      hiddenField.value = versionId
      form.appendChild(hiddenField)
    })

    // Add hidden fields for each selected tag
    this.selectedDiscoveries.forEach(tagId => {
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'tag_ids[]'
      hiddenField.value = tagId
      form.appendChild(hiddenField)
    })
  }

  updateGenerateButtonLabel() {
    const selectedVersions = this.selectedVersions
    const discoveryCount = this.selectedDiscoveryCount

    const totalExplanations = selectedVersions.length * discoveryCount

    if (this.hasVersionCountTarget) {
      this.versionCountTarget.textContent = selectedVersions.length
    }

    if (this.hasDiscoveryCountTarget) {
      this.discoveryCountTarget.textContent = discoveryCount
    }

    if (this.hasGenerateButtonTarget) {
      const buttonText = document.createElement('span')
      buttonText.textContent = `Generate ${totalExplanations} Explanations`

      // Replace the button text but keep the icon
      const button = this.generateButtonTarget
      const icon = button.querySelector('.icon')
      button.innerHTML = ''
      button.appendChild(icon)
      button.appendChild(buttonText)

      // Disable button if no explanations would be generated
      button.disabled = totalExplanations === 0
    }
  }

  get selectedVersions() {
    if (!this.hasVersionCheckboxTarget) return []
    return this.versionCheckboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value)
  }

  get selectedDiscoveries() {
    if (!this.hasTagSelectTarget) return []

    // Get all discovery IDs associated with selected tags
    // We'll handle this on the server side by sending tag IDs
    return Array.from(this.tagSelectTarget.selectedOptions).map(option => option.value)
  }

  get selectedDiscoveryCount() {
    if (!this.hasTagSelectTarget) return 0

    // Calculate total discovery count from data attributes
    return Array.from(this.tagSelectTarget.selectedOptions)
      .reduce((total, option) => {
        return total + parseInt(option.dataset.discoveryCount || 0)
      }, 0)
  }
}
